import { required, prop } from '@rxweb/reactive-form-validators';

export class CustomerModel {
	@required()
	name: string;

	@prop({name: 'active'})
	active: string;

	@prop({ name: 'razon_social' })
	razon_social: string;

	@prop({ name: 'nombre_comercial' })
	nombre_comercial: string;

	@prop({ name: 'reels_limit' })
	reels_limit: string;

	@prop({ name: 'units_limit' })
	units_limit: string;

	@prop({ name: 'media_limit' })
	media_limit: string;

	@prop({ name: 'groups_limit' })
	groups_limit: string;

}
